import { BookIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ContextualHelp from '@/components/atoms/ContextualHelp/ContextualHelp';
import { EVENT_RESOLVE_DOCS_URL } from '@/util/constants';

import ToolkitWrapper from '../../ToolkitWrapper';

const ToolkitActionClose = () => {
  const { t } = useTranslation();
  return (
    <ToolkitWrapper type="close">
      <ContextualHelp
        preventClose
        name="action-close"
        title={t('dialog.resolve.title')}
        links={[
          { label: t('docs.docs'), url: EVENT_RESOLVE_DOCS_URL, icon: <BookIcon size={16} /> },
        ]}
      >
        {t('dialog.resolve.body')}
      </ContextualHelp>
    </ToolkitWrapper>
  );
};

export default ToolkitActionClose;
